module.exports = __webpack_public_path__ + "img/application_bg5.8bc1ae6d.jpg";